
import ClientesScreen from '../../Base/Screens/Clientes/ClientesScreen';
import PlannerMasterWipScreen from '../../Screen/Planeacion/WIP/PlannerMasterWipScreen'
import CotizacionesScreen from '../../Screen/Ventas/Cotizaciones/CotizacionesScreen';
import CotizacionesListScreen from '../../Screen/Ventas/CotizacionesList/CotizacionesList';
import FacturacionDiariaScreen from '../../Screen/Ventas/FacturacionDiariaScreen';
import ResumenVentasScreen from '../../Screen/Ventas/ResumenVentas/ResumenVentasScreen';
import SalesOrdersScreen from '../../Screen/Ventas/SalesOrders/SalesOrdersScreen';
import BalanceHilazaScreen from '../../Screen/Ventas/SalesOrders/BalanceHilaza/BalanceHilazaScreen'

export const VentasRoutes = [
  {
    path: 'Ventas/MasterTimeLine',
    permiso: 135,
    element: <PlannerMasterWipScreen />,
  },
  {
    path: 'Ventas/ResumenVentas',
    permiso: 24,
    element: <ResumenVentasScreen />,
  },
  {
    path: 'Ventas/Clientes',
    permiso: 110,
    element: <ClientesScreen Finanzas={false} />,
  },
  {
    path: 'Ventas/Cotizaciones',
    permiso: 112,
    element: <CotizacionesListScreen />,
  },
  {
    path: 'Ventas/CostosCotizacion',
    permiso: 113,
    element: <CotizacionesScreen />,
  },
  {
    path: 'Ventas/SalesOrders',
    permiso: 131,
    element: <SalesOrdersScreen />,
  },
  {
    path: 'Ventas/FacturacionDiaria',
    permiso: 25,
    element: <FacturacionDiariaScreen />,
  },
  {
    path: 'Ventas/BalanceHilaza',
    permiso: 148,
    element: <BalanceHilazaScreen />,
  },
]

export default VentasRoutes;